var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.7,
    height: 27.285,
    viewBox: "0 0 27.7 27.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775",
    transform: "translate(0.253 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M32.49,11.766a3.733,3.733,0,0,0-2.838-1.243H25.593a6.4,6.4,0,0,0-11.548,0H9.987a3.7,3.7,0,0,0-3.736,4.209L8.036,29.683a4.637,4.637,0,0,0,4.487,3.983h14.59A4.638,4.638,0,0,0,31.6,29.683l1.784-14.951A3.731,3.731,0,0,0,32.49,11.766ZM19.819,8.773a4.52,4.52,0,1,1-4.52,4.521A4.526,4.526,0,0,1,19.819,8.773Zm11.688,5.734L29.722,29.458a2.733,2.733,0,0,1-2.609,2.317H12.523a2.736,2.736,0,0,1-2.609-2.316L8.131,14.506a1.81,1.81,0,0,1,1.856-2.091h3.487a6.413,6.413,0,1,0,12.689,0h3.488a1.81,1.81,0,0,1,1.856,2.091Z",
    transform: "translate(-6.222 -6.881)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M42.78,21.644a.946.946,0,1,0,1.336-1.338l-2.638-2.638a.946.946,0,1,0-1.338,1.339Z",
    transform: "translate(-29.415 -14.126)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weightIcon.6eb5bb8763a9636c945ff49f69c524d3.svg";
export { ForwardRef as ReactComponent };